/*
 * PRD-037 — App SEPARADA del portal del partner. Router + auth + LAYOUT propios; NO importa el
 * AuthContext/router/axiosInstance del panel. Se monta desde src/index.tsx para /partner y
 * /pre-registro. Layout con navegacion + paginas de gestion (dashboard, comercios, alta, detalle).
 */
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { PartnerAuthProvider, usePartnerAuth } from './PartnerAuthContext';
import PartnerLayout from './PartnerLayout';
import PartnerLogin from './pages/PartnerLogin';
import Dashboard from './pages/Dashboard';
import CommerceList from './pages/CommerceList';
import CreateCommerce from './pages/CreateCommerce';
import CommerceDetail from './pages/CommerceDetail';
import PartnerDraftMenu from './pages/PartnerDraftMenu';
import ClaimPage from './pages/ClaimPage';

// Si no hay sesion de partner → login; si hay → layout con las paginas de gestion (Outlet).
const ShellGate = () => {
  const { token } = usePartnerAuth();
  return token ? <PartnerLayout /> : <PartnerLogin />;
};

const DraftGate = () => {
  const { token } = usePartnerAuth();
  return token ? <PartnerDraftMenu /> : <Navigate to="/partner" replace />;
};

const router = createBrowserRouter([
  { path: '/pre-registro/:token', element: <ClaimPage /> },
  { path: '/partner/draft/:id/menu', element: <DraftGate /> },
  {
    path: '/partner',
    element: <ShellGate />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'comercios', element: <CommerceList /> },
      { path: 'comercios/nuevo', element: <CreateCommerce /> },
      { path: 'comercios/:id', element: <CommerceDetail /> },
    ],
  },
  { path: '*', element: <Navigate to="/partner" replace /> },
]);

const PartnerApp = () => (
  <PartnerAuthProvider>
    <RouterProvider router={router} />
  </PartnerAuthProvider>
);

export default PartnerApp;
